import moment from 'moment/moment';

import api from '../api/service/api.service';
import { PaginationQueryParams,FilterTypes } from '../types';

import { parseQueryFilters, parseBankingTransactionFilters } from './parseQueryFilters';


export const downloadCsvorExcel = async (
  targetPath: string,
  request: 'GET' | 'POST',
  filename: string,
  fileType: 'csv' | 'excel',
  paginationQueryParams?: PaginationQueryParams,
) => {
  let queryFilters = '';
  if (filename === 'transactions_List') {
     queryFilters = parseBankingTransactionFilters(paginationQueryParams?.filters as FilterTypes);
  } else {
     queryFilters = parseQueryFilters(paginationQueryParams?.filters);
  }
  const targetUrl = `${targetPath}/?${
    paginationQueryParams?.match ? `&match=${paginationQueryParams.match}` : ''
  }${queryFilters || ''}`;

  try {
    let response;

    if (request === 'GET') {
      response = await api.get(targetUrl);
    } else {
      response = await api.post(
        targetUrl,
        {},
        {
          responseType: 'blob',
        },
      );
    }

    const blob = new Blob([response.data], { type: fileType === 'csv' ? 'text/csv' : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const time = moment().format('HH-mm');

    const url = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = `${filename}--${time}.${fileType === 'csv' ? 'csv' : 'xlsx'}`;

    link.click();

    window.URL.revokeObjectURL(url);

    return response;
  } catch (error) {
    console.error('Error downloading CSV file:', error);
  }
};
